import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-genesys-iframe',
  templateUrl: './genesys-iframe.component.html',
  styleUrls: ['./genesys-iframe.component.scss']
})
export class GenesysIframeComponent implements OnInit {
  @Input()
  iframeUrl: string;

  @Input()
  title: string;

  @Input()
  allowList = 'fullscreen';

  bypassedIframeUrl: SafeResourceUrl;

  constructor(private sanitized: DomSanitizer) {}

  ngOnInit(): void {
    this.bypassedIframeUrl = this._bypassResourceUrl();
  }

  /**
   * Bypass security and trust the given value to be a safe resource URL
   * @returns A SafeResourceUrl
   */

  private _bypassResourceUrl(): SafeResourceUrl {
    return this.sanitized.bypassSecurityTrustResourceUrl(this.iframeUrl);
  }
}
